import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyGeneric = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M66.5 40.0002C66.5 25.3647 54.6355 13.5002 40 13.5002C25.3645 13.5002 13.5 25.3647 13.5 40.0002C13.5 54.6358 25.3645 66.5002 40 66.5002C54.6355 66.5002 66.5 54.6358 66.5 40.0002ZM68.5 40.0002C68.5 55.7403 55.7401 68.5002 40 68.5002C24.2599 68.5002 11.5 55.7403 11.5 40.0002C11.5 24.2601 24.2599 11.5002 40 11.5002C55.7401 11.5002 68.5 24.2601 68.5 40.0002Z",
		fill: "#D0D0D2"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M64.2598 11.8274C64.6313 11.4187 65.2642 11.3885 65.6729 11.76C66.0815 12.1315 66.1117 12.7644 65.7402 13.1731L15.7402 68.1731C15.3687 68.5817 14.7358 68.6119 14.3271 68.2405C13.9185 67.869 13.8883 67.236 14.2598 66.8274L64.2598 11.8274Z",
		fill: "#D0D0D2"
	})]
});
export default SvgEmptyGeneric;
